module.exports = __webpack_public_path__ + "static/media/tftm.31080067.png";